export const experienceData = [
    {
        id: 1,
        company: 'LICET Pattarai',
        jobtitle: 'Head of Student Relations',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 2,
        company: 'Estates India',
        jobtitle: 'Web developer',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 3,
        company: 'LICET Pattarai',
        jobtitle: 'Frontend Developer',
        startYear: '2021',
        endYear: 'Present'
    },
]